class ScrollFadeUp {
  /**
   * 
   * @param {string|HTMLElement} selector 
   * @param {object} options
   *    options.start - ScrollTrigger start
   *    options.duration - 动画时间
   *    options.y - 位移距离
   *    options.delay - 延时刷新，避免pin影响
   */
  constructor(selector, options = {}) {
    this.targets = typeof selector === 'string' ? document.querySelectorAll(selector) : selector;
    if (!this.targets || this.targets.length === 0) return;
    if (options.enable === false) return;
    
    this.start = options.start || "top top";
    this.end = options.end || "top top";
    this.duration = options.duration || 0.6;
    this.y = options.y || 50;
    this.delay = options.delay || 50;
    this.init();
  }

  init() {
    // 初始隐藏
    gsap.set(this.targets, { opacity: 0, y: this.y });

    setTimeout(() => {
      this.targets.forEach(target => {
        let visible = false; // 元素当前状态，true = 显示

        ScrollTrigger.create({
          trigger: target,
          start: this.start,
          end: this.end,
          markers: false,
          onEnter: (self) => {
            // 向下滚动到 start
            if (!visible && self.direction > 0) {
              visible = true;
              gsap.to(target, { opacity: 1, y: 0, duration: this.duration, ease: "power2.out" });
            } else if (visible && self.direction > 0) {
              visible = false;
              gsap.to(target, { opacity: 0, y: this.y, duration: this.duration, ease: "power2.in" });
            }
          },
          onEnterBack: (self) => {
            // 向上滚动到 start
            if (visible && self.direction < 0) {
              visible = false;
              gsap.to(target, { opacity: 0, y: this.y, duration: this.duration, ease: "power2.in" });
            } else if (!visible && self.direction < 0) {
              visible = true;
              gsap.to(target, { opacity: 1, y: 0, duration: this.duration, ease: "power2.out" });
            }
          }
        });
      });

      ScrollTrigger.refresh();
    }, this.delay);
  }
}
